export const METABASE_SITE_URL = "https://watchtower-api.edgetier.com/reporting/embed/dashboard/:token/#titled=true";
